import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { HrmBankAccount } from "../../../models/hrm-bank-account.model";

@Component({
  selector: "ngx-hrm-bank-account-form",
  templateUrl: "./hrm-bank-account-form.component.html",
  styleUrls: ["./hrm-bank-account-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HrmBankAccountFormComponent extends BaseFormComponent<HrmBankAccount> {
  public apiName: string = "CostCenter";
  public label: string = "ارتباط حساب کارکنان به محل خدمت";

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "HrmBankAccount";
    this.areaName = "Payroll";
    this.defaultCoumnNumber = 6;
    super.ngOnInit();
  }
  setdefault(): void {
    if (this.accountService.authService.getHrmPayCurentYearMonth()) {
      if (
        this.accountService.authService.getHrmPayCurentYearMonth().CurentYear &&
        this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth
      ) {
        this.model.IssueYear = this.accountService.authService.getHrmPayCurentYearMonth().CurentYear;
        this.model.IssueMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth;
      }
      if (!this.model.PersCode) this.model.PersCode = this.currentrow.PersCode;
      if (!this.model.FirstName) this.model.FirstName = this.currentrow.FirstName;
      if (!this.model.LastName) this.model.LastName = this.currentrow.LastName;
      if (!this.model.HrmPersonnelId) this.model.HrmPersonnelId = this.currentrow.HrmPersonnelId;
    }
  }
}
